export default __webpack_public_path__ + "/dist/images/9037340.png";